<template>
  <div
    class="h-full grid gap-x-3 p-2.5"
    style="grid-template-columns: auto 1fr auto"
  >
    <div class="overflow-y-hidden huiyi-detail-wangzhan-box-l">
      <div v-for="class_item in state.template_class" :key="class_item">
        <ul>
          {{
            class_item
          }}
        </ul>
        <ul>
          <li
            v-for="template in state.templates.filter(
              (w) => w.class == class_item,
            )"
            :key="template.id"
            :class="
              state.selects?.some((w) => w.field == template.field)
                ? 'active'
                : ''
            "
            class="cursor-pointer"
            @click="onSelect(template)"
          >
            <el-icon v-if="template.del_disabled" :size="10"
              ><StarFilled /></el-icon
            >{{ template.title }}
          </li>
        </ul>
      </div>
      <ul class="text-gray-400 text-xs">
        <el-icon :size="10"><StarFilled /></el-icon>
        新增自定义内容筹建中
      </ul>
      <!-- <div>
        <ul>
          会务常用
        </ul>
        <ul>
          <li class="active">交通到达</li>
          <li class="">交通返程</li>
          <li class="">酒店住宿</li>
        </ul>
      </div>
      <div>
        <ul>
          基础
        </ul>
        <ul>
          <li class="">交通到达</li>
          <li class="">交通返程</li>
          <li class="">酒店住宿</li>
        </ul>
      </div> -->
    </div>
    <div class="bg-gray-100 p-2.5 rounded-lg flex flex-col overflow-hidden">
      <div class="flex-1 flex flex-col gap-y-3 overflow-y-auto">
        <transition-group class="container" name="list" tag="div">
          <template v-for="item in state.selects" :key="item">
            <div
              class="bg-white rounded-lg p-2.5 flex-col mb-2"
              :draggable="true"
              @dragstart="dragstart(item)"
              @dragenter="dragenter(item, $event)"
              @dragend="getDragend"
            >
              <template v-if="item.type != 'object'">
                <div class="flex items-start">
                  <li class="text-sm flex-1 font-bold">
                    {{ item.title }}
                  </li>
                  <el-button
                    type="danger"
                    :icon="Delete"
                    link
                    @click="
                      state.selects = state.selects.filter(
                        (w) => w.field != item.field,
                      )
                    "
                    :disabled="item.del_disabled"
                    :title="item.del_disabled ? '基础信息禁止删除' : ''"
                    >删除
                  </el-button>
                  <el-button type="warning" :icon="Sort" link>
                    左键点击拖动排序
                  </el-button>
                </div>
                <div class="flex flex-wrap gap-x-5 gap-y-2 mt-2">
                  <div>
                    <ul class="text-xs text-gray-400 mb-1">
                      异常提示文本
                    </ul>
                    <el-input v-model="item.require_msg" />
                  </div>
                  <div v-if="item.type == 'input'">
                    <ul class="text-xs text-gray-400 mb-1">
                      占位提示文本
                    </ul>
                    <el-input v-model="item.placeholder" />
                  </div>
                  <div v-for="config in item.configs" :key="config">
                    <ul class="text-xs text-gray-400 mb-1">
                      {{
                        config.title
                      }}
                    </ul>
                    <el-radio-group
                      v-model="item['config_' + config.field]"
                      :disabled="item.del_disabled"
                      :title="
                        item.del_disabled ? '基础信息不允许设置非必填' : ''
                      "
                      :fill="
                        item['config_' + config.field] === 1
                          ? '#37926d'
                          : item['config_' + config.field] === 0
                          ? '#f00'
                          : '#fff'
                      "
                    >
                      <el-radio-button
                        v-for="value in config.options"
                        :key="value"
                        :label="value.label"
                        :value="value.value"
                      />
                    </el-radio-group>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="flex items-start">
                  <div class="text-sm">
                    <ul class="text-sm font-bold">
                      {{
                        item.title
                      }}
                    </ul>
                    <el-tag type="warning">组合表单</el-tag>
                  </div>
                  <div class="flex-1 mx-5 flex items-center gap-x-5">
                    <div v-for="config in item.configs" :key="config">
                      <ul class="text-xs text-gray-400">
                        {{
                          config.title
                        }}
                      </ul>
                      <el-radio-group
                        v-model="item['config_' + config.field]"
                        :fill="
                          item['config_' + config.field] === 1
                            ? '#37926d'
                            : item['config_' + config.field] === 0
                            ? '#f00'
                            : '#fff'
                        "
                      >
                        <el-radio-button
                          v-for="value in config.options"
                          :key="value"
                          :label="value.label"
                          :value="value.value"
                        />
                      </el-radio-group>
                    </div>
                  </div>
                  <el-button
                    type="danger"
                    :icon="Delete"
                    link
                    @click="
                      state.selects = state.selects.filter(
                        (w) => w.field != item.field,
                      )
                    "
                    :disabled="item.del_disabled"
                    :title="item.del_disabled ? '基础信息禁止删除' : ''"
                    >删除
                  </el-button>
                  <el-button type="warning" :icon="Sort" link>
                    左键点击拖动排序
                  </el-button>
                </div>
                <div
                  v-for="(child, childIndex) in item.items"
                  :key="child"
                  class="pl-3 mt-2"
                >
                  <div class="flex items-start">
                    <li class="text-sm flex-1 font-bold">
                      {{ child.title }}
                    </li>
                    <el-button
                      type="danger"
                      :icon="Delete"
                      link
                      @click="item.items.splice(childIndex, 1)"
                      :disabled="item.del_disabled"
                      :title="item.del_disabled ? '基础信息禁止删除' : ''"
                      >删除
                    </el-button>
                  </div>
                  <div class="flex flex-wrap gap-x-5 gap-y-2 mt-1">
                    <div>
                      <ul class="text-xs text-gray-400 mb-1">
                        异常提示文本
                      </ul>
                      <el-input v-model="child.require_msg" />
                    </div>
                    <div v-if="['input', 'datetime'].includes(child.type)">
                      <ul class="text-xs text-gray-400 mb-1">
                        占位提示文本
                      </ul>
                      <el-input v-model="child.placeholder" />
                    </div>
                    <div v-for="config in child.configs" :key="config">
                      <ul class="text-xs text-gray-400 mb-1">
                        {{
                          config.title
                        }}
                      </ul>
                      <el-radio-group
                        v-model="child['config_' + child.field]"
                        :fill="
                          child['config_' + child.field] === 1
                            ? '#37926d'
                            : child['config_' + child.field] === 0
                            ? '#f00'
                            : '#fff'
                        "
                      >
                        <el-radio-button
                          v-for="value in config.options"
                          :key="value"
                          :label="value.label"
                          :value="value.value"
                        />
                      </el-radio-group>
                    </div>
                    <div v-if="child.type == 'room'">
                      <ul class="text-xs text-gray-400 mb-1">
                        配置项
                      </ul>
                      <el-select v-model="child.tem_value" class="!w-56">
                        <el-option
                          v-for="(value, index) in child.options"
                          :key="value"
                          :label="value.name"
                          :value="value.name"
                        >
                          <div class="w-full flex items-center">
                            <li class="flex-1">{{ value.name }}</li>
                            <el-icon
                              color="#f00"
                              @click.stop="child.options.splice(index, 1)"
                            >
                              <Close />
                            </el-icon>
                          </div>
                        </el-option>
                        <template #footer>
                          <el-button
                            plain
                            class="float-right mb-3"
                            size="small"
                            @click="
                              state.room_options = child.options || [];
                              state.showRoomAdd = true;
                            "
                          >
                            添加选项
                          </el-button>
                        </template>
                      </el-select>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </transition-group>
      </div>
      <el-button type="primary" class="mt-2" @click="onSubmit"
        >保存表单</el-button
      >
    </div>
    <div
      class="bg-gray-100 p-2.5 rounded-lg flex flex-col gap-y-3 overflow-y-auto"
    >
      <strong>预览</strong>
      <div>
        <el-form
          :model="state.preview"
          label-width="auto"
          label-position="top"
          ref="formDom"
          size="large"
          class="flex-1 overflow-y-auto w-64"
        >
          <template v-for="item in state.selects" :key="item">
            <div v-if="item.type == 'object'">
              <ul class="mt-4 text-xs font-bold">
                {{
                  item.title
                }}
              </ul>
              <div class="p-2.5 mt-2 bg-white">
                <el-form-item
                  v-for="child in item.items"
                  :key="child"
                  :label="child.title"
                  :prop="child.field"
                  :rules="[
                    {
                      required: child['config_' + child.field],
                      message: child.require_msg,
                      trigger: 'blur',
                    },
                  ]"
                  class="flex-1"
                >
                  <el-input
                    v-model="state.preview[child.field]"
                    class="!w-56"
                    :placeholder="child.placeholder"
                    v-if="child.type == 'input'"
                  />
                  <el-radio-group
                    v-model="state.preview[child.field]"
                    v-else-if="child.type == 'radio'"
                    fill="#37926d"
                  >
                    <template v-for="value in child.options" :key="value">
                      <el-radio
                        :value="value.value"
                        v-if="
                          !value.unconfirm ||
                          (value.unconfirm &&
                            item['config_' + item.field + '_show_unconfirm'])
                        "
                      >
                        {{ value.label }}
                      </el-radio>
                    </template>
                  </el-radio-group>
                  <el-date-picker
                    v-model="state.preview[child.field]"
                    v-else-if="child.type == 'date'"
                    :placeholder="child.placeholder"
                    type="date"
                    format="YYYY-MM-DD"
                    value-format="YYYY-MM-DD"
                  />
                  <el-date-picker
                    v-model="state.preview[child.field]"
                    v-else-if="child.type == 'datetime'"
                    :placeholder="child.placeholder"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  />
                  <el-time-picker
                    v-else-if="child.type == 'time'"
                    v-model="state.preview[child.field]"
                    :placeholder="child.placeholder"
                    format="HH:mm"
                    value-format="HH:mm"
                  />
                  <el-date-picker
                    v-else-if="child.type == 'daterange'"
                    v-model="state.preview[child.field]"
                    type="daterange"
                    range-separator="至"
                    :start-placeholder="child.title"
                    :end-placeholder="child.title"
                    format="YYYY-MM-DD"
                    value-format="YYYY-MM-DD"
                  />
                  <el-select
                    v-else-if="child.type == 'room'"
                    v-model="state.preview[child.field]"
                    :placeholder="child.placeholder"
                  >
                    <el-option
                      v-for="value in child.options"
                      :key="value"
                      :label="value.name"
                      :value="value.name"
                    >
                      <div class="flex items-center">
                        <li class="w-14 flex-1">{{ value.name }}</li>
                        <li class="flex-1 text-xs text-gray-400 ml-3">
                          {{ "可住" + value.num + "人" }}
                        </li>
                        <text class="text-red-400">
                          {{ $priceFormat(value.price) }}
                        </text>
                        <text class="text-xs text-gray-400">/晚</text>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="bg-white p-2.5" v-else>
              <el-form-item
                :label="item.title"
                :prop="item.field"
                :rules="[
                  {
                    required: item['config_require'],
                    message: item.require_msg,
                    trigger: 'blur',
                  },
                ]"
                class="bg-white !mb-0"
              >
                <el-input
                  v-model="state.preview[item.field]"
                  class="!w-56"
                  v-if="item.type == 'input'"
                  :placeholder="item.placeholder"
                />
                <el-radio-group
                  v-model="state.preview[item.field]"
                  v-else-if="item.type == 'radio'"
                  fill="#37926d"
                >
                  <template v-for="value in item.options" :key="value">
                    <el-radio :value="value.value">
                      {{ value.label }}
                    </el-radio>
                  </template>
                </el-radio-group>
                <el-date-picker
                  v-model="state.preview[item.field]"
                  v-else-if="item.type == 'date'"
                  :placeholder="item.placeholder"
                  type="date"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                />
                <el-time-picker
                  v-else-if="item.type == 'time'"
                  v-model="state.preview[item.field]"
                  :placeholder="item.placeholder"
                  format="HH:mm"
                  value-format="HH:mm"
                />
              </el-form-item>
            </div>
          </template>
          <el-button type="primary" class="w-full mt-3" @click="onJudge">
            校验预览
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
  <el-dialog
    v-model="state.showRoomAdd"
    title="添加房型"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showRoomAdd = false;
      }
    "
    align-center
    :width="400"
  >
    <c_room_add @confirm="onRoomAdd" />
  </el-dialog>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import { onMounted, reactive, ref } from "vue";
import { data_configMeetingWebsiteSignupForm } from "@/http/data";
import {
  meeting_website_form_get,
  meeting_website_form_save,
} from "@/http/meeting";
import { post_response } from "@/utils/funcs";

import c_room_add from "./RoomAdd.vue";

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_room_add,
  },
  setup(props) {
    const formDom = ref(null);
    const state = reactive({
      room_options: [], //房型数组
      selects: [], //已选字段
      templates: [],
      selects_old: [
        {
          title: "姓名",
          type: "input",
          field: "name",
          require_msg: "请填写姓名",
          require: true,
          del_disabled: true, //禁止删除
          items: [
            {
              title: "必填",
              field: "require",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
          ],
        },
        {
          title: "性别",
          type: "radio",
          field: "sex",
          require_msg: "请填写姓名",
          require: true,
          del_disabled: true, //禁止删除
          options: [
            { label: "男", value: 1 },
            { label: "女", value: 2 },
          ],
          items: [
            {
              title: "必填",
              field: "require",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
          ],
        },
        {
          title: "手机号",
          type: "input",
          field: "phone",
          require_msg: "请填写手机号",
          items: [
            {
              title: "必填",
              field: "require",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
          ],
        },
        {
          title: "证件号",
          type: "input",
          field: "idcard",
          require_msg: "请填写证件号",
          items: [
            {
              title: "必填",
              field: "require",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
          ],
        },
        {
          title: "交通到达",
          type: "object",
          items: [
            {
              title: "必填",
              field: "require",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "只在嘉宾报名页显示",
              field: "show_jiabin",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "允许待定选项",
              field: "show_unconfirm",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "是否需要购票",
              require_msg: "请选择是否需要购票",
              field: "need_ticket",
              type: "radio",
              options: [
                { label: "需要", value: 1 },
                { label: "不需要", value: 0 },
                { label: "待定", value: 2, unconfirm: true },
              ],
            },
            {
              title: "是否需要接机(站)",
              require_msg: "请选择是否需要接机(站)",
              field: "need_ticket",
              type: "radio",
              options: [
                { label: "需要", value: 1 },
                { label: "不需要", value: 0 },
                { label: "待定", value: 2, unconfirm: true },
              ],
            },
            {
              title: "到达地",
              field: "arrive_address",
              require_msg: "请填写到达地点",
              type: "input",
            },
            {
              title: "到达日期",
              field: "arrive_address",
              require_msg: "请选择到达日期",
              type: "date",
            },
            {
              title: "到达时间",
              field: "arrive_address",
              require_msg: "请选择到达时间",
              type: "time",
            },
          ],
        },
        {
          title: "交通返程",
          type: "object",
          items: [
            {
              title: "必填",
              field: "require",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "只在嘉宾报名页显示",
              field: "show_jiabin",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "允许待定选项",
              field: "show_unconfirm",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "是否需要购票",
              field: "need_ticket",
              type: "radio",
              require_msg: "请选择是否需要购票",
              options: [
                { label: "需要", value: 1 },
                { label: "不需要", value: 0 },
                { label: "待定", value: 2, unconfirm: true },
              ],
            },
            {
              title: "是否需要接机(站)",
              field: "need_ticket",
              type: "radio",
              require_msg: "请选择是否需要接机(站)",
              options: [
                { label: "需要", value: 1 },
                { label: "不需要", value: 0 },
                { label: "待定", value: 2, unconfirm: true },
              ],
            },
            {
              title: "到达地",
              field: "arrive_address",
              require_msg: "请选择填写到达地点",
              type: "input",
            },
            {
              title: "到达日期",
              field: "arrive_address",
              require_msg: "请选择到达日期",
              type: "date",
            },
            {
              title: "到达时间",
              field: "arrive_address",
              require_msg: "请选择到达时间",
              type: "time",
            },
          ],
        },
        {
          title: "酒店住宿",
          type: "object",
          items: [
            {
              title: "必填",
              field: "require",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "只在嘉宾报名页显示",
              field: "show_jiabin",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "允许待定选项",
              field: "show_unconfirm",
              type: "switch",
              options: [
                { label: "开启", value: 1 },
                { label: "关闭", value: 0 },
              ],
            },
            {
              title: "是否需要安排住宿",
              field: "need_room",
              require_msg: "请选择是否需要安排住宿",
              type: "radio",
              options: [
                { label: "需要", value: 1 },
                { label: "不需要", value: 0 },
                { label: "待定", value: 2, unconfirm: true },
              ],
            },
            {
              title: "住宿日期",
              require_msg: "请选择住宿日期",
              field: "room_date",
              type: "daterange",
            },
            {
              title: "房型",
              require_msg: "请选择房型",
              field: "room_type",
              type: "room",
              options: [],
            },
          ],
        },
      ],
      preview: {},
    });
    onMounted(() => {
      onLoadTemplate();
      onLoad();
      // state.selects = JSON.parse(
      //   JSON.stringify(templates.filter((item) => item.del_disabled === 1)),
      // );
    });

    const onLoadTemplate = () => {
      data_configMeetingWebsiteSignupForm().then((res) => {
        if (res.status == 200) {
          state.templates = res.data?.data?.value || [];

          state.template_class = state.templates.reduce((acc, item) => {
            if (!acc.includes(item.class)) acc.push(item.class);
            return acc;
          }, []);
        }
      });
    };

    const onLoad = () => {
      meeting_website_form_get(props.meeting_id).then((res) => {
        if (res.status == 200) {
          state.selects = res.data?.data?.form_data || [];
        }
      });
    };

    const onSelect = (item) => {
      const index = state.selects.findIndex((i) => i.field === item.field);
      if (index > -1) {
        if (!item.del_disabled) {
          state.selects = state.selects.filter((i) => i.field != item.field);
        }
      } else {
        state.selects.push(JSON.parse(JSON.stringify(item)));
      }
    };

    const dragstart = (value) => {
      state.oldData = value;
      state.dragStartId = value;
    };
    const dragenter = (value) => {
      state.newData = value;
      state.dragEndId = value;
    };
    const getDragend = () => {
      if (state.oldData !== state.newData) {
        let oldIndex = state.selects.indexOf(state.oldData);
        let newIndex = state.selects.indexOf(state.newData);
        let newItems = [...state.selects];
        // 删除之前DOM节点
        newItems.splice(oldIndex, 1);
        // 在拖拽结束目标位置增加新的DOM节点
        newItems.splice(newIndex, 0, state.oldData);
        // 每次拖拽结束后，将拖拽处理完成的数据，赋值原数组，使DOM视图更新，页面显示拖拽动画
        state.selects = newItems;
        // 每次拖拽结束后调用接口时时保存数据
      }
    };

    const onRoomAdd = (item) => {
      if (state.room_options?.some((w) => w.name == item.name)) {
        ElMessage.error("房型名称重复，添加失败！");
        return;
      }

      state.room_options.push(item);
      delete state.showRoomAdd;
    };

    const onJudge = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessage.success("校验通过");
        }
      });
    };

    const onSubmit = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-success);">保存</strong>当前表单配置吗？`,
        "保存表单",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_website_form_save({
          meeting_id: props.meeting_id,
          form_data: JSON.stringify(state.selects),
        }).then((res) => {
          post_response(res, onLoad);
        });
      });
    };

    return {
      state,
      dragstart,
      dragenter,
      getDragend,
      formDom,
      onJudge,
      onSelect,
      onRoomAdd,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
.huiyi-detail-wangzhan-box-l {
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  & > div {
    & > ul:first-child {
      font-weight: bold;
      font-size: 80%;
    }

    & > ul:last-child {
      margin-top: 10px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 10px;
      row-gap: 10px;

      & > li {
        width: 80px;
        background-color: #f6f6f6;
        text-align: center;
        border-radius: 5px;
        padding: 10px 0;
        font-size: 12px;
      }

      & > .active {
        background-color: #37926d;
        color: #fff;
        font-weight: 600;
      }
    }
  }
}
</style>
